import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../config/supabase';
import './Pages.css';
import Navbar from '../components/Navbar';

function Home() {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isFeaturesSectionVisible, setIsFeaturesSectionVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);

      // Check if features section is visible
      const featuresSection = document.querySelector('.features-section');
      if (featuresSection) {
        const rect = featuresSection.getBoundingClientRect();
        const isVisible = rect.top <= window.innerHeight / 2;
        setIsFeaturesSectionVisible(isVisible);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleGetStarted = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (session) {
      navigate('/esrs-reporting');
    } else {
      navigate('/login');
    }
  };

  return (
    <div className={`page-container ${isFeaturesSectionVisible ? 'light-mode' : ''}`}>
      <Navbar isScrolled={isScrolled} />

      <main className="main-content">
        <div className="floating-container">
          <div className="hero-section">
            <div className="hero-content">
              <h1>The AI Reporting Platform</h1>
              <p className="hero-text">
                Built to make you extraordinarily productive,<br />
                Hympact is the best way to report on CSRD with AI.
              </p>
              <button className="cta-button" onClick={handleGetStarted}>
                GET STARTED
              </button>
              <div className="platform-image">
                <img src="/Platform.png" alt="Platform Preview" className="platform-preview" />
              </div>
            </div>
          </div>
        </div>

        <section className="features-section">
          <h2 className="section-title">Why Choose Hympact?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>Double Materiality</h3>
              <p>Seamlessly analyze and report on both impact and financial materiality with our intuitive tools.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>ESRS Compliance</h3>
              <p>Stay compliant with European Sustainability Reporting Standards through our guided framework.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">💡</div>
              <h3>Smart Analytics</h3>
              <p>Gain valuable insights with our advanced analytics and reporting capabilities.</p>
            </div>
          </div>
        </section>

        <section className="benefits-section">
          <div className="benefits-content">
            <h2 className="section-title">Streamline Your Reporting Process</h2>
            <div className="benefits-grid">
              <div className="benefit-item">
                <span className="benefit-number">01</span>
                <h4>Time Efficiency</h4>
                <p>Reduce reporting time by up to 60%</p>
              </div>
              <div className="benefit-item">
                <span className="benefit-number">02</span>
                <h4>Accuracy</h4>
                <p>Minimize errors with automated validation</p>
              </div>
              <div className="benefit-item">
                <span className="benefit-number">03</span>
                <h4>Compliance</h4>
                <p>Stay up-to-date with latest CSRD requirements</p>
              </div>
            </div>
          </div>
        </section>

        <section className="supported-by-section">
          <div className="supported-content">
            <h2 className="section-title">Supported By</h2>
            <div className="supporters-grid">
              <div className="supporter-item">
                <img 
                  src={process.env.PUBLIC_URL + '/images/epfl_ip.png'} 
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/images/epfl_ip.png';
                    console.log('Trying fallback path for EPFL IP logo');
                  }}
                  alt="EPFL Innovation Park" 
                  className="supporter-logo" 
                />
              </div>
              <div className="supporter-item">
                <img 
                  src={process.env.PUBLIC_URL + '/images/Laforge.png'} 
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/images/Laforge.png';
                    console.log('Trying fallback path for Laforge logo');
                  }}
                  alt="Laforge" 
                  className="supporter-logo" 
                />
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Home; 


